import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { isDevToolsEnabled } from '../env';

interface NoAiState {
    noAi: boolean;
    toggle: () => void;
}

export const useNoAiStore = create<NoAiState>()(
    persist(
        (set) => ({
            noAi: false,
            toggle: () => set((state) => ({ noAi: !state.noAi })),
        }),
        {
            name: 'no-ai-mode',
            // In staging/prod, ignore any persisted value and always start with noAi: false.
            merge: (persisted, current) =>
                isDevToolsEnabled ? { ...current, ...(persisted as object) } : current,
        }
    )
);
